import React from "react";
import camera_icon from "../../assets/icons/camera_icon.png";
import scanner_icon from "../../assets/icons/scanner_icon.png";
import text_icon from "../../assets/icons/text_icon.png";
import { Link } from "react-router-dom";
import HomePage from "../../pages/HomePage";

const CreateModal = () => {
  return (
    <div>
      <HomePage />
      <div className="modal-wrapper"></div>
      <div className="modal-container py-4 px-10 rounded-lg w-[30%]">
        <div className="flex justify-center flex-col items-center">
          <div className="text-[20px] my-4 font-bold">Add Lead</div>
          <div className="text-[16px]">
            Please select one of the options for adding the lead.
          </div>
          <div className="flex mt-6">
            <div className="text-[14px] flex flex-col items-center cursor-pointer">
              <img src={camera_icon} alt="camera"/>
              Camera
            </div>
            <div className="text-[14px] mx-4  flex flex-col items-center cursor-pointer">
              <img src={scanner_icon} alt="scanner"/>
              Scanner
            </div>
            <Link to="/create">
              <div className="text-[14px]  flex flex-col items-center cursor-pointer">
                <img src={text_icon} alt="text"/>
                Textual
              </div>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateModal;
